/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Box, Card, CardContent, Tooltip, Typography } from '@mui/material';
import { withStyles } from '@material-ui/core';

import { showToast } from 'modules/layout/layout.actions';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

import { getAuthTripsByAuthId, postAuthTrip, updateAuthTrip, deleteAuthTrip } from './store/actions/authorizations.actions';

import CrudTable from 'modules/clients/details/crudTable.component';
import Spinner from 'modules/common/spinner.component';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { calculateTripDuration, formatTripAddress } from 'modules/authorizations/utils';
import { RENTAL_CAR_CLASS_IDS, ZERO_GUID } from 'modules/enumerations/enumerationIds';
import {
  GET_AUTH_DESTINATION_SERVICES_FAILURE,
  GET_GLOBAL_INFO_FAILURE,
  GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE,
  GET_CANDIDATE_SERVICES_FAILURE,
  UPSERT_BUYER_TRIP_FAILURE,
  UPSERT_RENTER_TRIP_FAILURE,
  UPSERT_ASSIGNMENT_TRIPS_FAILURE,
  UPSERT_TEMP_LIVING_TRIP_FAILURE,
  UPSERT_CANDIDATE_TRIP_FAILURE,
  DELETE_RENTER_TRIP_FAILURE,
  DELETE_BUYER_TRIP_FAILURE,
  DELETE_ASSIGNMENT_TRIPS_FAILURE,
  DELETE_CANDIDATE_TRIP_FAILURE,
  DELETE_TEMP_LIVING_TRIP_FAILURE,
  GET_BUYER_TRIP_FAILURE,
  GET_RENTER_TRIP_FAILURE
} from './types';
import {
  deleteAssignmentTrip,
  deleteBuyerTrip,
  deleteTemporaryLivingTrip,
  deleteCandidateTrip,
  deleteRenterTrip,
  getAuthDestinationServices,
  getGlobalInfo,
  getInternServices,
  upsertAssignmentTrip,
  upsertBuyerTrip,
  upsertCandidateTrip,
  upsertRenterTrip,
  upsertTemporaryLivingTrip
} from './authorizations.actions';
import { getTemporaryLivingAssignments } from './store/actions/temporaryLiving.actions';
import { getCandidateServices } from './store/actions/canidateTrip.actions';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  },
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  },
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  chipClickable: {
    cursor: 'pointer'
  },
  iconOverlayImg: {
    position: 'absolute'
  },
  spacingX: {
    marginRight: theme.spacing(1)
  },
  footer: {
    height: 15,
    marginBottom: theme.spacing(2)
  },
  mb2: {
    marginBottom: '4px',
    marginRight: '16px'
  },
  editModalContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100% !important',
    marginLeft: '0px !important'
  },
  editModalColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100% !important'
  },
  editModalInput: {
    minWidth: '332px'
  },
  dialogContentContainer: {
    margin: '15px'
  },
  labelText: {
    minWidth: 350,
    marginBottom: 0
  }
});

const AuthTripSummaryCard = props => {
  const { familyMembers, id, addresses, trips, rentalCarClassesEnum, tripCategories, provinces, countries } = props;

  const [isLoading, setIsLoading] = useState(false);

  let family = familyMembers
    ? familyMembers.map(f => {
      return f.firstName + ' ' + f.lastName;
    })
    : [];

  let addressLines = addresses
    ? addresses
      .map(a => {
        const addressLabel = formatTripAddress(a, provinces, countries);
        return {
          ...a,
          id: a.addressId,
          title: addressLabel,
          description: addressLabel
        };
      })
      .filter(s => s.excludeAddressFromSelection === false)
    : [];

  const formatAddress = address => {
    if (!address) return '';

    const parts = [address.addressLineOne, address.city, address.state].filter(part => part);

    return parts.join(', ');
  };

  //TODO - Are these suppose to be enumerations stored in DB?
  const tripTypes = ['One Way', 'Round-Trip'];
  const tripBooking = ['TRC Booking', 'Self Booked'];
  const tripCategoryOptions =
    tripCategories && tripCategories.length > 0
      ? tripCategories.filter(s => s.isActive === true)
      : [{ id: ZERO_GUID, title: '' }];
  const rentalCarClassOptions =
    rentalCarClassesEnum && rentalCarClassesEnum.length > 0
      ? rentalCarClassesEnum
      : [{ id: ZERO_GUID, title: '' }];
  const categories = [
    { id: 0, title: 'tripSummary' },
    { id: 1, title: 'airTransport', conditionalRender: 'airTransport' },
    { id: 2, title: 'hotelBooking', conditionalRender: 'hotelBooking' },
    { id: 3, title: 'rentalCarBooking', conditionalRender: 'rentalCarBooking' }
  ];

  const tripColumns = [
    { header: 'Trip Title', accessorKey: 'tripName', type: 'text', required: true, size: 70, tab: 1, categoryType: 'tripSummary' },
    {
      header: 'Trip Category',
      accessorKey: 'tripCategoryId',
      type: 'dropdown-v2',
      options: tripCategoryOptions,
      categoryType: 'tripSummary',
      tab: 1,
      size: 70,
      required: true,
      Cell: ({ cell }) => (cell.getValue() ? tripCategoryOptions.find(trip => trip.id === cell.getValue()).title : '-')
    },
    {
      header: 'Family Attending',
      accessorKey: 'familyAttending',
      type: 'multi-select',
      Cell: ({ cell }) =>
        cell.getValue()
          ? typeof cell.getValue() === 'string'
            ? cell
              .getValue()
              .split(',')
              .map(f => <div key={f}>{f}</div>)
            : cell.getValue().map(f => <div key={f}>{f}</div>)
          : '-',
      options: family,
      required: false,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Journey',
      accessorKey: 'typeOfTrip',
      type: 'dropdown',
      options: tripTypes,
      required: true,
      tab: 1,
      categoryType: 'tripSummary',
      hideInTable: true
    },
    {
      header: 'Origin',
      accessorKey: 'departureAddressId',
      type: 'dropdown-v2',
      Cell: ({ cell }) =>
        cell.getValue() && addresses && addresses.length > 0 ? formatAddress(addresses.find(a => a.addressId === cell.getValue())) : '-',
      options: addressLines,
      required: true,
      size: 70,
      categoryType: 'tripSummary',
      tab: 1
    },
    {
      header: 'Destination',
      accessorKey: 'destinationAddressId',
      type: 'dropdown-v2',
      Cell: ({ cell }) =>
        cell.getValue() && addresses && addresses.length > 0 ? formatAddress(addresses.find(a => a.addressId === cell.getValue())) : '-',
      options: addressLines,
      required: true,
      size: 70,
      categoryType: 'tripSummary',
      tab: 1
    },

    {
      header: 'Trip Start Date',
      accessorKey: 'tripStartDate',
      type: 'date',
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-'),
      required: false,
      tab: 1,
      categoryType: 'tripSummary',
      size: 60
    },
    {
      header: 'Trip End Date',
      accessorKey: 'tripEndDate',
      type: 'date',
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString('en-us') : '-'),
      required: false,
      tab: 1,
      categoryType: 'tripSummary',
      size: 60
    },
    {
      header: 'Total Nights',
      accessorKey: 'tripDuration',
      type: 'number',
      disabled: true,
      required: false,
      tab: 1,
      categoryType: 'tripSummary',
      hideInTable: true
    },
    {
      header: 'Special Needs',
      accessorKey: 'specialNeeds',
      type: 'text',
      required: false,
      tab: 1,
      categoryType: 'tripSummary',
      hideInTable: true
    },
    {
      header: 'Booking Type',
      accessorKey: 'hasBookingDetails',
      type: 'dropdown-bool',
      default: 'Self Booked',
      options: tripBooking,
      required: true,
      categoryType: 'tripSummary',
      tab: 1,
      hideInTable: true
    },
    // Air Transport
    {
      accessorKey: 'airTransport',
      header: 'Air Transport',
      type: 'checkbox',
      required: false,
      size: 70,
      hideInTable: true,
      defaultVal: false,
      categoryType: 'airTransport',
      conditional: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Departure Date',
      accessorKey: 'airTransportDepartureDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'airTransport',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Arrival Date',
      accessorKey: 'airTransportArrivalDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'airTransport',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Return Departure Date',
      accessorKey: 'airTransportReturnDepartureDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'airTransport',
      dependentOn: 'typeOfTrip',
      dependentValue: 'Round-Trip',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Return Arrival Date',
      accessorKey: 'airTransportReturnArrivalDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'airTransport',
      dependentOn: 'typeOfTrip',
      dependentValue: 'Round-Trip',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    // Hotel Booking
    {
      accessorKey: 'hotelBooking',
      header: 'Hotel',
      type: 'checkbox',
      required: false,
      size: 70,
      categoryType: 'hotelBooking',
      hideInTable: true,
      defaultVal: false,
      conditional: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Hotel Name',
      accessorKey: 'hotelName',
      type: 'text',
      required: false,
      tab: 1,
      categoryType: 'hotelBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Hotel Address',
      accessorKey: 'hotelAddressId',
      type: 'dropdown-v2',
      Cell: ({ cell }) =>
        cell.getValue() && addresses && addresses.length > 0 ? formatAddress(addresses.find(a => a.addressId === cell.getValue())) : '-',
      options: addressLines,
      required: false,
      categoryType: 'hotelBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking',
      tab: 1
    },
    {
      header: 'Check In',
      accessorKey: 'hotelCheckInDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'hotelBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Check Out',
      accessorKey: 'hotelCheckOutDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'hotelBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Duration of Stay',
      accessorKey: 'hotelDurationOfStay',
      type: 'number',
      required: false,
      tab: 1,
      disabled: true,
      categoryType: 'hotelBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    // Rental Car
    {
      accessorKey: 'rentalCarBooking',
      header: 'Rental Car',
      type: 'checkbox',
      required: false,
      size: 70,
      hideInTable: true,
      defaultVal: false,
      categoryType: 'rentalCarBooking',
      conditional: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Rental Car Class',
      accessorKey: 'rentalCarClassId',
      type: 'dropdown-v2',
      options: rentalCarClassOptions,
      categoryType: 'rentalCarBooking',
      hideInTable: true,
      required: false,
      tab: 1,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Please Specify Rental Car Class',
      accessorKey: 'otherRentalCar',
      type: 'text',
      required: false,
      dependentOn: 'rentalCarClassId',
      dependentValue: RENTAL_CAR_CLASS_IDS.OTHER,
      categoryType: 'rentalCarBooking',
      tab: 1,
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Rental Car Start Date',
      accessorKey: 'rentalCarStartDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'rentalCarBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Rental Car End Date',
      accessorKey: 'rentalCarEndDate',
      type: 'date',
      required: false,
      tab: 1,
      categoryType: 'rentalCarBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    },
    {
      header: 'Rental Duration',
      accessorKey: 'rentalCarDuration',
      type: 'number',
      required: false,
      tab: 1,
      disabled: true,
      categoryType: 'rentalCarBooking',
      hideInTable: true,
      displayDependent: 'hasBookingDetails',
      displayDependentVal: 'TRC Booking'
    }
  ];

  const updateTrip = async (trip, values) => {
    setIsLoading(true);
    const tripId = trip.original.tripId;

    let newValues = { ...trip.original };

    newValues.tripName = values.tripName;
    newValues.tripCategoryId = values.tripCategoryId;
    newValues.typeOfTrip = values.typeOfTrip;
    newValues.tripStartDate = values.tripStartDate;
    newValues.tripEndDate = values.tripEndDate;
    newValues.specialNeeds = values.specialNeeds;

    if (values.hasBookingDetails && values.hasBookingDetails === tripBooking[0]) {
      newValues.hasBookingDetails = false;
    } else {
      newValues.hasBookingDetails = true;
    }

    newValues.airTransport = values.airTransport;
    newValues.airTransportDepartureDate = values.airTransportDepartureDate;
    newValues.airTransportArrivalDate = values.airTransportArrivalDate;
    newValues.airTransportReturnDepartureDate = values.airTransportReturnDepartureDate;
    newValues.airTransportReturnArrivalDate = values.airTransportReturnArrivalDate;

    newValues.hotelBooking = values.hotelBooking;
    newValues.hotelName = values.hotelName;
    newValues.hotelAddressId = values.hotelAddressId;
    newValues.hotelCheckInDate = values.hotelCheckInDate;
    newValues.hotelCheckOutDate = values.hotelCheckOutDate;
    newValues.hotelDurationOfStay = values.hotelDurationOfStay;

    newValues.rentalCarBooking = values.rentalCarBooking;
    newValues.rentalCarClassId = values.rentalCarClassId;
    newValues.otherRentalCar = values.otherRentalCar;
    newValues.rentalCarStartDate = values.rentalCarStartDate;
    newValues.rentalCarEndDate = values.rentalCarEndDate;
    newValues.rentalCarDuration = values.rentalCarDuration;

    newValues.departureDate = values.tripStartDate;
    newValues.arrivalDate = values.tripEndDate;
    newValues.tripDuration = calculateTripDuration(values.tripStartDate, values.tripEndDate, values.tripDuration);

    if (Array.isArray(values.familyAttending)) {
      newValues.familyAttending = values.familyAttending ? values.familyAttending.join(',') : values.familyAttending;
    }
    if (typeof values.familyAttending === 'object') {
      let familyString = '';
      values.familyAttending.map(a => {
        familyString = familyString + a + ',';
      });
      newValues.familyAttending = familyString;
    }

    switch (values.tripCategoryId) {
      case 'c0041355-c75d-4a0c-b2a9-69baf891e0d5':
        // Homefinding / Destination Renter or buyer:
        const destServicesResp = await props.getAuthDestinationServices(id);
        if (destServicesResp.type === GET_AUTH_DESTINATION_SERVICES_FAILURE) {
          setIsLoading(false);
          return false;
        }

        // Check buyer trips
        if (destServicesResp.response && Array.isArray(destServicesResp.response.buyerTrips)) {
          const foundBuyerTrip = destServicesResp.response.buyerTrips.find(t => t.tripId === tripId);
          if (foundBuyerTrip) {
            const homefindingResp = await props.upsertBuyerTrip(destServicesResp.response.destinationBuyerInfo.buyerServiceId, newValues);
            if (homefindingResp.type === UPSERT_BUYER_TRIP_FAILURE) {
              setIsLoading(false);
              return false;
            }
            setIsLoading(false);
            return true;
          }
        }

        // Check renter trips
        if (destServicesResp.response && Array.isArray(destServicesResp.response.renterTrips)) {
          const foundRenterTrip = destServicesResp.response.renterTrips.find(t => t.tripId === tripId);
          if (foundRenterTrip) {
            const homefindingResp = await props.upsertRenterTrip(
              destServicesResp.response.destinationRenterInfo.renterServiceId,
              newValues
            );
            if (homefindingResp.type === UPSERT_RENTER_TRIP_FAILURE) {
              setIsLoading(false);
              return false;
            }
            setIsLoading(false);
            return true;
          }
        }

        setIsLoading(false);
        return true;
      case '644f419f-072d-49ad-a86c-58052b45175c':
        // Global:
        const globalInfoResp = await props.getGlobalInfo(id);
        if (globalInfoResp.type === GET_GLOBAL_INFO_FAILURE) {
          setIsLoading(false);
          return false;
        }

        // Parse through global info to find the assignmentId
        let globalAssignmentId = null;

        if (globalInfoResp.response) {
          globalAssignmentId = globalInfoResp.response.globalInfo.globalAssignmentId;
        }

        if (!globalAssignmentId) {
          setIsLoading(false);
          return false;
        }
        const globalResp = await props.upsertAssignmentTrip(globalAssignmentId, newValues);
        if (globalResp.type === UPSERT_ASSIGNMENT_TRIPS_FAILURE) {
          setIsLoading(false);
          return false;
        }
        setIsLoading(false);
        return true;
      case 'aab171b4-a184-4c91-841f-30702fbaff99':
        // Temp living:
        const tempLivingResp = await props.getTemporaryLivingAssignments(id);
        if (tempLivingResp.type === GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE) {
          setIsLoading(false);
          return false;
        }

        // Parse through temp living assignments to find the matching trip and get assignmentId
        let tempLivingAssignmentId = null;

        if (tempLivingResp.response && Array.isArray(tempLivingResp.response)) {
          for (const assignment of tempLivingResp.response) {
            if (assignment.trips && Array.isArray(assignment.trips)) {
              const foundTrip = assignment.trips.find(t => t.tripId === tripId);
              if (foundTrip) {
                tempLivingAssignmentId = assignment.temporaryLivingAssignmentId;
                break;
              }
            }
          }
        }
        if (!tempLivingAssignmentId) {
          setIsLoading(false);
          return false;
        }
        const tlResp = await props.upsertTemporaryLivingTrip(tempLivingAssignmentId, newValues);
        if (tlResp.type === UPSERT_TEMP_LIVING_TRIP_FAILURE) {
          setIsLoading(false);
          return false;
        }
        setIsLoading(false);
        return true;
      default:
        // Candidate or Intern:
        const candidateServicesResp = await props.getCandidateServices(id);
        if (candidateServicesResp.type === GET_CANDIDATE_SERVICES_FAILURE) {
          setIsLoading(false);
          return false;
        }

        const candidateResp = await props.upsertCandidateTrip(
          candidateServicesResp.response.candidateInternService.candidateInternServiceId,
          newValues
        );
        if (candidateResp.type === UPSERT_CANDIDATE_TRIP_FAILURE) {
          setIsLoading(false);
          return false;
        }
        setIsLoading(false);
        return true;
    }
  };

  const deleteTrip = async trip => {
    setIsLoading(true);
    switch (trip.tripCategoryId) {
      case 'c0041355-c75d-4a0c-b2a9-69baf891e0d5':
        // Homefinding / Destination Renter or buyer:
        // First find out if renter or buyer
        const buyerResp = await props.getBuyerTripById(trip.tripId);
        if (buyerResp.type === GET_BUYER_TRIP_FAILURE) {
          // verify is renter trip
          const renterResp = await props.getRenterTripById(trip.tripId);
          if (renterResp.type === GET_RENTER_TRIP_FAILURE) {
            // cannot delete
            props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
            setIsLoading(false);
            return false;
          } else {
            const renterUpsertResp = await props.deleteRenterTrip(trip.tripId);
            if (renterUpsertResp.type === DELETE_RENTER_TRIP_FAILURE) {
              props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
              setIsLoading(false);
              return false;
            } else {
              setIsLoading(false);
              return true;
            }
          }
        } else {
          const buyerUpsertResp = await props.deleteBuyerTrip(trip.tripId);
          if (buyerUpsertResp.type === DELETE_BUYER_TRIP_FAILURE) {
            props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
            setIsLoading(false);
            return false;
          } else {
            setIsLoading(false);
            return true;
          }
        }
      case '644f419f-072d-49ad-a86c-58052b45175c':
        // Global:
        const globalResp = await props.deleteAssignmentTrip(trip.tripId);
        if (globalResp.type === DELETE_ASSIGNMENT_TRIPS_FAILURE) {
          props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      case 'aab171b4-a184-4c91-841f-30702fbaff99':
        // Temp living:
        const tlResp = await props.deleteTemporaryLivingTrip(trip.tripId);
        if (tlResp.type === DELETE_TEMP_LIVING_TRIP_FAILURE) {
          props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      case '9c64495d-3e5d-4d6b-873a-533899eaa7ac':
        // Candidate:
        const candidateResp = await props.deleteCandidateTrip(trip.tripId);
        if (candidateResp.type === DELETE_CANDIDATE_TRIP_FAILURE) {
          props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      case 'b9b60681-1acd-48a1-8509-8b675c703b4d':
        // Intern 1 way:
        const internOneWayResp = await props.deleteCandidateTrip(trip.tripId);
        if (internOneWayResp.type === DELETE_CANDIDATE_TRIP_FAILURE) {
          props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      case 'b6a894e9-2ccc-4da6-bd38-9594e9d7af80':
        // Intern round trip:
        const internRoundResp = await props.deleteCandidateTrip(trip.tripId);
        if (internRoundResp.type === DELETE_CANDIDATE_TRIP_FAILURE) {
          props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsLoading(false);
          return false;
        } else {
          setIsLoading(false);
          return true;
        }
      default:
        props.showToast('Failed to delete the current trip info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        setIsLoading(false);
        return false;
    }
  };

  return (
    <>
      <Card sx={{ marginTop: '16px' }}>
        <Box>
          <CardContent className={props.classes.cardContainer}>
            <div className="row justify-space-between align-center">
              <div className={props.classes.iconRow}>
                <Tooltip title={'Money'} key={'Auth Trips'} placement="right">
                  <FontAwesomeIcon icon={['fas', 'fa-plane-departure']} size="2x" />
                </Tooltip>
                <Typography variant="h5" sx={{ paddingLeft: '20px', fontSize: '1.3125rem', fontWeight: 'bold' }}>
                  Trips
                </Typography>
              </div>
            </div>
          </CardContent>
          <CardContent sx={{ padding: '10px', marginLeft: '30px' }}>
            {!isLoading && (
              <CrudTable
                editingMode={'modal'} // Can be changed to 'row' to edit inline
                columns={tripColumns}
                rows={trips || []}
                updateRow={updateTrip}
                deleteRow={deleteTrip}
                hideAdd={true}
                hideEdit={Boolean(props.hideEdit)}
                categories={categories}
                showBasicTable={true}
              />
            )}
            {isLoading && <Spinner />}
          </CardContent>
        </Box>
      </Card>
    </>
  );
};

AuthTripSummaryCard.propTypes = {
  id: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const { rentalCarClasses, tripCategories, provinces, countries } = state.enumerations.allEnums;
  return {
    rentalCarClassesEnum: rentalCarClasses,
    tripCategories: tripCategories,
    provinces,
    countries
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthTripsByAuthId,
    postAuthTrip,
    updateAuthTrip,
    deleteAuthTrip,
    showToast,
    upsertAssignmentTrip,
    upsertBuyerTrip,
    upsertRenterTrip,
    upsertCandidateTrip,
    upsertTemporaryLivingTrip,
    getAuthDestinationServices,
    getGlobalInfo,
    getTemporaryLivingAssignments,
    getCandidateServices,
    getInternServices,
    deleteRenterTrip,
    deleteBuyerTrip,
    deleteAssignmentTrip,
    deleteTemporaryLivingTrip,
    deleteCandidateTrip
  })
)(AuthTripSummaryCard);
